import { useEffect, useRef } from 'react';
import { getPersonProfileShortInfo } from '../../store/slices/personsSlice/personsSlice';
import { useAppDispatch } from '../../store/hooks';

const POLL_INTERVAL = 5000; // 5 секунд
const MAX_DURATION = 15 * 60 * 1000; // 15 минут
const LOCAL_STORAGE_KEY = 'emailConfirmationStart';

export function useEmailConfirmationPolling() {
  const dispatch = useAppDispatch();
  const pollIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const stopPolling = () => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  const shouldContinuePolling = () => {
    const startTime = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!startTime) return false;
    const elapsed = Date.now() - parseInt(startTime, 10);
    return elapsed < MAX_DURATION;
  };

  const poll = () => {
    if (!shouldContinuePolling()) {
      stopPolling();
      return;
    }

    dispatch(getPersonProfileShortInfo()).then(({ payload }) => {
      if (payload?.emailConfirmation) {
        stopPolling();
      }
    });
  };

  const startPolling = () => {
    // Установить стартовое время, если ещё не установлено
    if (!localStorage.getItem(LOCAL_STORAGE_KEY)) {
      localStorage.setItem(LOCAL_STORAGE_KEY, Date.now().toString());
    }

    poll(); // Первый запуск
    pollIntervalRef.current = setInterval(poll, POLL_INTERVAL);
  };

  useEffect(() => {
    if (shouldContinuePolling()) {
      startPolling();
    }

    return () => {
      stopPolling();
    };
  }, []);

  return {
    startPolling,
    stopPolling,
  };
}
